module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3n1r2n-6ab6e9f95c9cecac007f1aa93afb9cb1.svg";